import { render, staticRenderFns } from "./FbTextArea.vue?vue&type=template&id=46e1cbe6&scoped=true"
import script from "./FbTextArea.vue?vue&type=script&lang=js"
export * from "./FbTextArea.vue?vue&type=script&lang=js"
import style0 from "./FbTextArea.vue?vue&type=style&index=0&id=46e1cbe6&prod&lang=scss&scoped=true"
import style1 from "./FbTextArea.vue?vue&type=style&index=1&id=46e1cbe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1cbe6",
  null
  
)

export default component.exports